import React from 'react'

const Loading = () => {
  return (
    <div className="loading-spinner-container">
    <div className="loading-spinner"></div>
    <p style={{ fontSize: "16px" }}>Loading....</p>
    </div>
  )
}

export default Loading